import Vue from 'vue';
import VideoTrailer from '../../video-trailer/index.vue'
import CourseBladesButtons from '@/components/features/course-blades-buttons/index.vue'
import CourseBladesStatistic from '@/components/features/course-blades-statistic/index.vue'
import PackageAccessNotice from '@/components/features/package-access-notice/index.vue'

import vueSmoothScroll from 'vue2-smooth-scroll'

Vue.use(vueSmoothScroll)

export default {
    name: 'course-headers-blade-full-center',
    props: {
        item: {
            type: Object
        },
        courseInfo: {
            type: Object
        }
    },
    components: {
        VideoTrailer,
        CourseBladesButtons,
        CourseBladesStatistic,
        PackageAccessNotice,
    },
}
